import Reveal from "./Reveal";
import { APP_STORE_URL } from "../content";
import { Sticker, Starburst } from "./Stickers";

const CHECKS = [
  "Unlimited orders, clients & styles",
  "Checkflow System™ included",
  "Revenue analytics built in",
  "Cancel anytime",
];

function Check() {
  return (
    <span className="mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-pastel-mint">
      <svg viewBox="0 0 10 10" className="h-2.5 w-2.5" aria-hidden="true">
        <path
          d="M1.5 5.2 4 7.5 8.5 2.5"
          fill="none"
          stroke="#1C1917"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-16">
        <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <h2 className="max-w-xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink md:text-6xl">
            One app. Every order.
          </h2>
          <p className="max-w-sm text-base leading-relaxed text-ink/70">
            One app for the whole business. Less than a single custom set a
            month — start with 7 days free.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 border-t-2 border-ink md:mt-20 md:grid-cols-2">
          <div
            data-testid="pricing-monthly-card"
            className="border-b-2 border-ink py-10 md:border-b-0 md:border-r-2 md:pr-14"
          >
            <div className="flex items-center gap-3">
              <Sticker rotate="-rotate-2" bg="bg-pastel-pink">
                Monthly — 7-day free trial
              </Sticker>
            </div>
            <div className="mt-8 flex items-baseline gap-2">
              <span className="font-display text-6xl font-extrabold tracking-tight text-ink md:text-7xl">
                $19.99
              </span>
              <span className="font-display text-xs font-bold uppercase tracking-[0.14em] text-stone-500">
                / month
              </span>
            </div>
            <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-ink/70">
              Billed monthly through the App Store. 7 days free before it
              starts.
            </p>
            <ul className="mt-8 space-y-3.5">
              {CHECKS.map((c) => (
                <li
                  key={c}
                  className="flex gap-3 text-[15px] text-ink/80"
                >
                  <Check />
                  {c}
                </li>
              ))}
            </ul>
            <a
              data-testid="pricing-monthly-cta"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 block rounded-full border-2 border-ink bg-pastel-pink py-4 text-center font-display text-sm font-extrabold uppercase tracking-tight text-ink shadow-chunk transition-all duration-200 hover:-translate-y-0.5 hover:shadow-chunk-lg"
            >
              Start free trial
            </a>
          </div>

          <div
            data-testid="pricing-annual-card"
            className="relative py-10 md:pl-14"
          >
            <div className="absolute -top-7 right-4 hidden rotate-12 md:block">
              <Starburst text="Save $40.88" color="#BFE3CC" />
            </div>
            <div className="flex items-center gap-3">
              <Sticker rotate="rotate-2" bg="bg-pastel-mint">
                Annual
              </Sticker>
            </div>
            <div className="mt-8 flex items-baseline gap-2">
              <span className="font-display text-6xl font-extrabold tracking-tight text-ink md:text-7xl">
                $199
              </span>
              <span className="font-display text-xs font-bold uppercase tracking-[0.14em] text-stone-500">
                / year
              </span>
            </div>
            <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-ink/70">
              One payment a year — $40.88 under the monthly plan. Same
              everything.
            </p>
            <ul className="mt-8 space-y-3.5">
              {CHECKS.map((c) => (
                <li
                  key={c}
                  className="flex gap-3 text-[15px] text-ink/80"
                >
                  <Check />
                  {c}
                </li>
              ))}
            </ul>
            <a
              data-testid="pricing-annual-cta"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 block rounded-full border-2 border-ink bg-white py-4 text-center font-display text-sm font-extrabold uppercase tracking-tight text-ink shadow-chunk transition-all duration-200 hover:-translate-y-0.5 hover:bg-ink hover:text-bone hover:shadow-chunk-lg"
            >
              Start free trial
            </a>
          </div>
        </div>

        <Reveal className="mt-8 border-t-2 border-ink pt-6">
          <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-stone-600">
            Prices in USD · Trial & billing handled by the App Store
          </p>
        </Reveal>
      </div>
    </section>
  );
}
